<template>
    <div class="row mt-2">
        <div class="col-12" v-if="titulo">
            <label class="dx-field-item-label dx-field-item-label-location-top" :title="hint">
                <span class="dx-field-item-label-content">
                    <span class="dx-field-label-text" v-html="titulo"></span>
                    <span class="dx-field-item-required-mark" v-if="obrigatorio">&nbsp;*</span>
                </span>
            </label>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            obrigatorio: Boolean,
            titulo: String,
            hint: String
        }
    }
</script>